import React from 'react';

const CancelLr = (props) => {
    const handleRouteClick = (e) => {
        e.stopPropagation();
        if (!props.disabled) {
            props.onClickActive(props);
        }
    };
    const title = (props.tracking_type === "none") ? "Delete Invoice" : (props.tracking_type === "PTL1" ? "Disable Shipment" : "Cancel LR");
    return (
        <div 
            style={{ 
                cursor: props.disabled ? "not-allowed" : "pointer", 
                opacity: props.disabled ? 0.5 : 1 
            }}
        >
            <span onClick={handleRouteClick} title={props.disabled ? `${title}` : title}>
               {(props.tracking_type === "none")?
                <i className="fa fa-trash" style={{fontSize: "17px"}}></i>
                : <i className="icofont icofont-ban" style={{fontSize:"17px"}}></i> } 
            </span>
        </div>
    );
};

export default CancelLr;
